var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"fixed":"","temporary":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.$vuetify.goTo(item.href, {
        offset: -100
      }), _vm.inputValue = false}}},[_c('v-list-tile-title',{staticClass:"vlist-size",domProps:{"textContent":_vm._s(item.text)}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }